/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/clock_medium'
export default icon
